module.exports = __webpack_public_path__ + "fonts/NoirPro-Light.defbb591.eot";